import './footer.css';

export default() => {
  const init = () => {
    class FooterNavBox extends HTMLElement {
      connectedCallback() {
        this.querySelector('.footer-nav-box__header').addEventListener('click', () => {
          if (window.innerWidth < 1024) {
            this.classList.toggle('active');
          }
        });
      }
    };
    customElements.define('footer-nav-box', FooterNavBox);
  };

  init();
};
